import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/userActions';
let logo = require('../../components/navigation/logo.svg');
// import FontAwesome from 'react-fontawesome';

class LoginPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      submitting: false,
      errors: {},
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    let username = this.refs.username.value;
    let pass = this.refs.pass.value;
    this.props.actions.login(username, pass);
  }

  render() {
    // let loginUpBtnClass = "btn btn-block btn-lg";
    return (
      <div className="login-container">
        <div className="panel panel-default">
          <form onSubmit={this.handleSubmit}>
            <div className="panel-body">
              <img src={logo} alt=""/>
              <hr/>
              <div className="form-group">
                <label htmlFor="LoginUsername">Brukernavn</label>
                <input ref="username" type="username" className="form-control" id="LoginUsername" placeholder="Brukernavn" />
              </div>
              <div className="form-group">
                <label htmlFor="LoginPassword">Password</label>
                <input ref="pass"  type="password" className="form-control" id="LoginPassword" placeholder="Passord" />
              </div>
              <input type="submit" value="Log inn" className="btn btn-block btn-primary"/>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

LoginPage.propTypes = {
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    eventDetails: state.events.eventDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage);



/** WEBPACK FOOTER **
 ** ./src/containers/users/LoginPage.js
 **/